<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap>
				<app-card :fullBlock="true" colClasses="xs12">
					<v-card-title>
						<v-btn @click.stop="onAdd" color="primary" outline>
							<i class="material-icons">add</i>
							{{ $t("message.addNew") }}
						</v-btn>
						<!-- <order-catalogue /> -->
						<manage-catalogue
							:dialog.sync="showModal"
							:isCreate.sync="isCreate"
							@on-save="onSave"
							ref="manageCatalogueModal"
						></manage-catalogue>
						<v-spacer></v-spacer>
						<v-text-field
							append-icon="search"
							hide-details
							:label="$t('message.search')"
							single-line
							v-model="search"
						></v-text-field>
					</v-card-title>

					<v-data-table
						:headers="headers"
						:items="catalogues"
						:pagination.sync="pagination"
						:search="search"
						:total-items="totalCatalogue"
						no-data-text="No hay datos que mostrar"
						no-results-text="No hay resultados que mostrar"
					>
						<template slot="headerCell" slot-scope="props">
							<v-tooltip bottom>
								<span slot="activator">{{
									$t(`message.${props.header.text}`)
								}}</span>
								<span>{{ $t(`message.${props.header.text}`) }}</span>
							</v-tooltip>
						</template>
						<template slot="items" slot-scope="props">
							<td :class="{ disabled: props.item.status === 0 }">
								{{ props.item.name }}
							</td>
							<td :class="{ disabled: props.item.status === 0 }">
								{{ props.item.description }}
							</td>
							<td :class="{ disabled: props.item.status === 0 }">
								{{
									props.item.available
										? $t("message.enabled")
										: $t("message.disabled")
								}}
							</td>
							<td
								class="text-left"
								:class="{ disabled: props.item.status === 0 }"
							>
								<v-btn
									@click="onEdit(props.item)"
									color="primary"
									outline
									fab
									icon
									small
									:disabled="props.item.status === 0"
								>
									<v-icon class="zmdi zmdi-edit"></v-icon>
								</v-btn>
								<!-- <v-btn @click="onDelete(props.item)" color="error" dark fab icon small>
                  <v-icon light>cancel</v-icon>
                </v-btn> -->
							</td>
						</template>
					</v-data-table>
					<delete-confirmation-dialog
						@onConfirm="deleteCatalogue"
						:heading="$t('message.deleteConfirmation')"
						:message="$t('message.deleteMessage')"
						ref="deleteConfirmationDialog"
					></delete-confirmation-dialog>
				</app-card>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import {
	CREATE_CATALOGUE,
	GET_CATALOGUES,
	UPDATE_CATALOGUE,
	DELETE_CATALOGUE,
} from "../../store/modules/catalogues/actions.type";
import ManageCatalogue from "./ManageCatalogue";
import OrderCatalogue from "./OrderCatalogue.vue";

export default {
	name: "catalogueList",
	components: {
		ManageCatalogue,
		OrderCatalogue,
	},
	data() {
		return {
			headers: [
				{ text: "name", sortable: true, value: "name" },
				{ text: "description", sortable: true, value: "description" },
				{ text: "status", sortable: true, value: "available" },
				{ text: "actions", sortable: false, value: "" },
			],
			search: "",
			showModal: false,
			isCreate: true,
			selectedCatalogue: {},
			pagination: {},
		};
	},
	computed: {
		...mapGetters(["loadingCatalogue", "catalogues", "totalCatalogue"]),
	},
	watch: {
		pagination: {
			handler() {
				this.getCatalogues();
			},
			deep: true,
		},
	},
	created() {
		this.getCatalogues();
	},
	methods: {
		deleteCatalogue() {
			this.$store.dispatch(DELETE_CATALOGUE, this.selectedCatalogue.id);
			this.$refs.deleteConfirmationDialog.close();
		},
		hideCatalogue() {
			this.$store.dispatch(HIDE_CATALOGUE, this.selectedCatalogue.id);
			this.$refs.hideCatalogueDialog.close();
		},
		onDelete(catalogue) {
			this.selectedCatalogue = catalogue;
			this.$refs.deleteConfirmationDialog.openDialog();
		},
		onEdit(catalogue) {
			this.showModal = true;
			this.isCreate = false;
			this.selectedCatalogue = catalogue;
			this.$refs.manageCatalogueModal.setValue(catalogue);
		},
		onAdd() {
			this.showModal = true;
			this.isCreate = true;
		},
		getCatalogues() {
			this.$store.dispatch(GET_CATALOGUES, this.pagination);
		},
		onSave(catalogue) {
			if (this.isCreate) {
				this.$store.dispatch(CREATE_CATALOGUE, catalogue);
			} else {
				this.selectedCatalogue = Object.assign(
					{},
					this.selectedCatalogue,
					catalogue
				);
				this.$store.dispatch(UPDATE_CATALOGUE, this.selectedCatalogue);
			}
		},
	},
};
</script>

<style>
.disabled {
	background-color: #e6e6e6;
}
</style>
